import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import { AnalyticsStore, ContextStore, PageStore } from 'bernie-plugin-mobx';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { UitkSpacing, UitkSpacingProps } from 'uitk-react-spacing';

import { ListingsStore, SearchCriteriaStore } from '../../../stores';
import { trackAnalytics } from '../../../utility';
import { AnalyticsType } from '../../../types/shared';
import TriggerFlightsSearchParams from '../../../types/shared/trigger-flights-search-params';
import { ErrorEmptyState } from './error-empty-state';

interface SmartShoppingNoApiResponseProps extends LocalizedComponentProps, RouteComponentProps {
  searchCriteriaStore?: SearchCriteriaStore;
  listingsStore?: ListingsStore;
  context?: ContextStore;
  page?: PageStore;
  analytics?: AnalyticsStore;
}

const mainSpacingProps: UitkSpacingProps = {
  margin: { block: 'twelve' },
  padding: { block: 'twelve' }
};

@withLocalization
@inject('context', 'searchCriteriaStore', 'listingsStore', 'analytics', 'informationCriteriaStore', 'errorStore')
@observer
class SmartShoppingNoApiResponseComponent extends React.Component<SmartShoppingNoApiResponseProps> {
  private onClickAction = () => {
    const { searchCriteriaStore, listingsStore, context, analytics, location, history } = this.props;
    const onRetryAnalytics: AnalyticsType = {
      __typename: 'FlightsAnalytics',
      linkName: 'page.Flight.SS.FSR.Error',
      referrerId: 'FLT.SR.ErrorPage.Retry.Clicked'
    };
    const triggerSearchParams: TriggerFlightsSearchParams = {
      history,
      location,
      context,
      shouldForce: true,
      replaceHistory: true,
      fetchSearchForm: false
    };
    listingsStore.smartShoppingNoResponse = false;
    searchCriteriaStore.triggerSearch(triggerSearchParams);
    if (analytics) {
      trackAnalytics(onRetryAnalytics, analytics);
    }
  };
  public render() {
    const { l10n } = this.props;
    const headingText = l10n.formatText('server.error.heading');
    const bodyText = l10n.formatText('server.error.message');
    const buttonText = l10n.formatText('server.error.retry.button.text');

    return (
      <UitkSpacing margin={mainSpacingProps.margin} padding={mainSpacingProps.padding}>
        <ErrorEmptyState
          icon="error"
          headingTag="h1"
          title={headingText}
          body={bodyText}
          buttonText={buttonText}
          clickHandler={this.onClickAction}
        />
      </UitkSpacing>
    );
  }
}

export const SmartShoppingNoApiResponse = withRouter(SmartShoppingNoApiResponseComponent);
